import { Menu } from 'antd'

export const MenuItem = (props: any) => {
  return <Menu.Item {...props}>{props.children}</Menu.Item>
}
